<div style="text-align: center; display: flex">
  <img
    alt="DataMatrix Barcode"
    src="{{ configService.getConfig().apiServiceEndpoint }}v1/Barcode/DataMatrix/{{ barcodeID }}" />
</div>
